export {SmartContainer} from './smart-container';



// WEBPACK FOOTER //
// ./components/smart-container/index.js


// WEBPACK FOOTER //
// ui/components/smart-container/index.js